import React from 'react';
import { useTranslation } from 'react-i18next';

const PrivacyPolicy = () => {
    const { t } = useTranslation();

    return (
        <div className="container mx-auto px-4 py-8 max-w-4xl">
            <h1 className="text-3xl font-bold mb-8">{t('privacyPolicy')}</h1>
            
            {/* 1. Introduction */}
            <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">1. {t('introduction')}</h2>
                <p className="text-gray-700 leading-relaxed">
                    {t('privacyIntro')}
                </p>
            </section>

            {/* 2. Information We Collect */}
            <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">2. {t('infoWeCollect')}</h2>
                <p className="text-gray-700 mb-4">{t('infoWeCollectDesc')}</p>
                
                <h3 className="text-xl font-semibold mb-2">{t('personalInfo')}:</h3>
                <ul className="list-disc pl-6 mb-4 text-gray-700">
                    <li>{t('personalInfoItems.name')}</li>
                    <li>{t('personalInfoItems.email')}</li>
                    <li>{t('personalInfoItems.phone')}</li>
                    <li>{t('personalInfoItems.address')}</li>
                </ul>

                <h3 className="text-xl font-semibold mb-2">{t('bookTransactions')}:</h3>
                <ul className="list-disc pl-6 mb-4 text-gray-700">
                    <li>{t('bookTransactionsItems.details')}</li>
                    <li>{t('bookTransactionsItems.received')}</li>
                    <li>{t('bookTransactionsItems.purchased')}</li>
                </ul>

                <h3 className="text-xl font-semibold mb-2">{t('walletData')}:</h3>
                <ul className="list-disc pl-6 mb-4 text-gray-700">
                    <li>{t('walletDataItems.balance')}</li>
                    <li>{t('walletDataItems.history')}</li>
                    <li>{t('walletDataItems.refunds')}</li>
                </ul>

                <h3 className="text-xl font-semibold mb-2">{t('deviceData')}:</h3>
                <ul className="list-disc pl-6 mb-4 text-gray-700">
                    <li>{t('deviceDataItems.info')}</li>
                    <li>{t('deviceDataItems.cookies')}</li>
                </ul>
            </section>

            {/* 3. How We Use the Information */}
            <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">3. {t('howWeUseInfo')}</h2>
                <ul className="list-disc pl-6 text-gray-700">
                    <li>{t('howWeUseInfoItems.process')}</li>
                    <li>{t('howWeUseInfoItems.wallet')}</li>
                    <li>{t('howWeUseInfoItems.updates')}</li>
                    <li>{t('howWeUseInfoItems.improve')}</li>
                    <li>{t('howWeUseInfoItems.fraud')}</li>
                </ul>
            </section>

            {/* 4. How We Share the Data */}
            <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">4. {t('dataSharing')}</h2>
                <p className="text-gray-700 mb-4">{t('dataSharingDesc')}</p>
                <ul className="list-disc pl-6 mb-4 text-gray-700">
                    <li>{t('dataSharingItems.logistics')}</li>
                    <li>{t('dataSharingItems.payment')}</li>
                </ul>
                <p className="text-gray-700">{t('noDataSale')}</p>
            </section>

            {/* 5. Data Security */}
            <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">5. {t('dataSecurity')}</h2>
                <p className="text-gray-700 mb-4">{t('dataSecurityDesc')}</p>
                <ul className="list-disc pl-6 text-gray-700">
                    <li>{t('dataSecurityItems.encryption')}</li>
                    <li>{t('dataSecurityItems.storage')}</li>
                </ul>
            </section>

            {/* 6. User Rights */}
            <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">6. {t('userRights')}</h2>
                <p className="text-gray-700 mb-4">{t('userRightsDesc')}</p>
                <ul className="list-disc pl-6 mb-4 text-gray-700">
                    <li>{t('userRightsItems.access')}</li>
                    <li>{t('userRightsItems.copy')}</li>
                    <li>{t('userRightsItems.optout')}</li>
                    <li>{t('userRightsItems.withdraw')}</li>
                </ul>
                <p className="text-gray-700">{t('exerciseRights')}</p>
            </section>

            {/* 7. Cookies & Tracking */}
            <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">7. {t('cookies')}</h2>
                <p className="text-gray-700">{t('cookiesDesc')}</p>
            </section>

            {/* 8. Contact & Changes */}
            <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">8. {t('contact')}</h2>
                <p className="text-gray-700 mb-4">{t('contactDesc')}</p>
                <p className="text-gray-700 mb-4">
                    {t('email')}: <a href="mailto:privacy@bookik.com" className="text-[#3bb18f] hover:underline">privacy@bookik.com</a>
                </p>
                <p className="text-gray-700">{t('policyUpdates')}</p>
            </section>
        </div>
    );
};

export default PrivacyPolicy; 